<template>
  <div
    v-if="attributes"
    class="mt-8"
  >
    <KikAccordion
      :index="0"
      :open="true"
      :full-width="false"
    >
      <template #title>
        <h2 class="text-xl">
          {{ $t('Product details') }}
        </h2>
      </template>
      <AdditionalDetails
        class="mt-3"
        :info="attributes"
        :description="description"
        :product-number="productNumber"
      />
    </KikAccordion>
    <KikAccordion
      v-if="attributes.manufacturer_infos"
      :index="1"
      :full-width="false"
    >
      <template #title>
        <span class="text-xl font-bold">{{ $t('Manufacturer information') }}</span>
      </template>
      <Manufacturer
        class="mt-3"
        :info="attributes"
      />
    </KikAccordion>
    <KikAccordion
      v-if="hasHazardInstruction"
      :id="$t('Hazard notice')"
      :index="2"
      :full-width="false"
    >
      <template #title>
        <span class="text-xl font-bold">{{ $t('Hazard notice') }}</span>
      </template>
      <Hazard
        class="mt-3"
        :info="attributes"
      />
    </KikAccordion>
    <KikAccordion
      v-if="hasSafetyInstructions"
      :index="3"
      :full-width="false"
    >
      <template #title>
        <span class="text-xl font-bold">{{ $t('Safety instructions') }}</span>
      </template>
      <SafetyInstructions
        class="mt-3"
        :info="attributes"
      />
    </KikAccordion>
  </div>
</template>

<script lang="ts" setup>
import AdditionalDetails from './AdditionalInformation/Details.vue';
import Manufacturer from './AdditionalInformation/Manufacturer.vue';
import Hazard from './AdditionalInformation/Hazard.vue';
import SafetyInstructions from './AdditionalInformation/SafetyInstructions.vue';
import type { Variant } from './types/product';

interface Props {
  variant: Variant;
  description?: string;
  productNumber?: string;
}

const props = withDefaults(defineProps<Props>(), {
  description: undefined,
  productNumber: undefined,
});

const { $i18n } = useNuxtApp();

const attributes = computed(() => props.variant?.attributes || {});

const hasHazardInstruction = computed(() => {
  const { danger_icons: dangerIcons = [], hazard_notice: hazarNotice, signalword } = attributes.value;
  return dangerIcons?.length && signalword && hazarNotice;
});

const hasSafetyInstructions = computed(() => {
  const { safety_instructions: safetyInstructions } = attributes.value;
  return !!safetyInstructions?.length;
});

const openSafetyInformation = () => {
  const hazardElement = document.getElementById($i18n.t('Hazard notice'));
  hazardElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  hazardElement?.click();
};

defineExpose({ openSafetyInformation });
</script>
